import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { deleteCourtPriceDate } from '@/lib/venue/priceApi'

import { courtsQueryKey } from './useCourts'

/**
 * 날짜 지정 요금 해제(#866 API ④). 그날 규칙을 지우면 요일유형 규칙으로 되돌아간다.
 * 🚨 저장과 같은 이유로 응답을 소비하지 않고 목록을 무효화한다(설계 R1).
 */
export function useDeleteCourtPriceDate(venueId: string, courtId: number) {
  const queryClient = useQueryClient()

  return useMutation<void, ApiError, string>({
    mutationFn: (date) => deleteCourtPriceDate(venueId, courtId, date),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: courtsQueryKey(venueId) })
    },
  })
}
